import { DEFAULT_THEME_CSS_VARIABLES } from "./defaultThemeCssVars";

export const DEFAULT_THEME = {
  default_theme: {
    name: "default_theme",
    value: 1,
    cssVariables: DEFAULT_THEME_CSS_VARIABLES,
    isCustom: false,
  },
};
